import React from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Redirect } from "react-router-dom";
import { Table } from "../../components/CustomPaginations";
import { tableStyle } from "../ticketModule/variables/ListingVariables";
import { UserConsumer } from "../../UserContext";

const CheckInOutDetails = (props) => {
	const {
		pagerData,
		pageNum,
		numberOfItemsPerPage,
		employeeRecord,
		columns,
		defaultSorted,
		handleTableChange,
		flag,
		flagCount,
	} = props;
	return (
		<UserConsumer>
			{(userDetails) => {
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.id==="471" ||
					userDetails.empRole.includes("3") ? (
					<>
						<PaginationProvider
							pagination={paginationFactory({
								custom: true,
								totalSize: pagerData ? pagerData.TotalCount : 0,
								page: pageNum,
								sizePerPage: numberOfItemsPerPage,
								paginationSize: numberOfItemsPerPage,
							})}
						>
							{({ paginationProps, paginationTableProps }) => {
								return (
									<Table
										keyField="id"
										columns={columns}
										items={employeeRecord}
										tableStyle={tableStyle}
										paginationProps={paginationProps}
										paginationTableProps={
											paginationTableProps
										}
										tableLoader={props.isLoading}
										loading={props.isLoading}
										defaultSorted={defaultSorted}
										onTablePageChange={handleTableChange}
										showFeedback={false}
										headerClasses="details-thead"
										bodyClasses="details-table"
										bordered={false}
										pagination={paginationFactory()}
										pagerData={props.pagerData}
										SearchBar={() => {
											return null;
										}}
										receiveData={(PageSize) => {
											props.receiveData(PageSize);
										}}
										flag={flag}
										flagTitle={"Total Hours"}
										flagCount={flagCount}
									/>
								);
							}}
						</PaginationProvider>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default CheckInOutDetails;
